import css from "./SuporteIA.module.css";
export default function BarraDeSaida({ carregando = false, aoRecomecar }) {
  return (
    <div className={css.barraDeSaida}>
      <button type="button" disabled={carregando} onClick={aoRecomecar} className={css.botaoVazado}>
        Começar nova conversa
      </button>
    </div>
  );
}
